var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.825 3.78705C16.059 2.71771 17.5817 2.71105 17.8251 3.77831L17.8361 3.82699C17.8434 3.85987 17.8505 3.89014 17.8578 3.92172C18.1231 5.05147 19.0375 5.91471 20.1819 6.11382C21.2979 6.30798 21.2979 7.91009 20.1819 8.10425C19.0313 8.30442 18.1134 9.17582 17.8536 10.3145L17.8251 10.4398C17.5817 11.507 16.059 11.5004 15.825 10.431L15.8015 10.3235C15.5513 9.18079 14.6347 8.30298 13.4822 8.10248C12.3682 7.90866 12.3682 6.30941 13.4822 6.1156C14.6307 5.9158 15.5449 5.04339 15.7988 3.90651L15.8161 3.82768L15.825 3.78705ZM4.28002 3.05253C3.57309 3.05253 3 3.62562 3 4.33256V9.77267C3 10.4796 3.57309 11.0527 4.28002 11.0527H9.72015C10.4271 11.0527 11.0002 10.4796 11.0002 9.77267V4.33256C11.0002 3.62562 10.4271 3.05253 9.72015 3.05253H4.28002ZM3 14.2803C3 13.5733 3.57309 13.0002 4.28002 13.0002H9.72015C10.4271 13.0002 11.0002 13.5733 11.0002 14.2803V19.7204C11.0002 20.4274 10.4271 21.0004 9.72015 21.0004H4.28002C3.57309 21.0004 3 20.4274 3 19.7204V14.2803ZM12.9477 14.2803C12.9477 13.5733 13.5208 13.0002 14.2277 13.0002H19.6678C20.3748 13.0002 20.9479 13.5733 20.9479 14.2803V19.7204C20.9479 20.4274 20.3748 21.0004 19.6678 21.0004H14.2277C13.5208 21.0004 12.9477 20.4274 12.9477 19.7204V14.2803Z",
    fill: "#8C8B8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.b987fac4bb7679fe897255109e9ea8ef.svg";
export { ForwardRef as ReactComponent };